import { render } from "./Description.vue?vue&type=template&id=b7ce6fc8"
import script from "./Description.vue?vue&type=script&lang=js"
export * from "./Description.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__